module.exports = __webpack_public_path__ + "img/tour-3.40cbdedf.svg";